"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _uuid = require("uuid");

var _subscribeAdapterConstants = require("./subscribe-adapter-constants");

var _types = require("./types");

var createClientAdapter = function createClientAdapter(_ref) {
  var url = _ref.url,
      cursor = _ref.cursor,
      onEvent = _ref.onEvent,
      _ref$pullEventsTimeou = _ref.pullEventsTimeout,
      pullEventsTimeout = _ref$pullEventsTimeou === void 0 ? 30000 : _ref$pullEventsTimeou,
      _ref$pullEventsMaxAtt = _ref.pullEventsMaxAttempts,
      pullEventsMaxAttempts = _ref$pullEventsMaxAtt === void 0 ? 10 : _ref$pullEventsMaxAtt;
  var client;
  var _status = _types.SubscriptionAdapterStatus.Initializing;
  var currentCursor = cursor;
  var pullEventsRequestId = null;
  var pullEventsTimeoutInstance = null;
  var isWaitingForExtraPulling = false;
  return {
    init: function init() {
      if (_status === _types.SubscriptionAdapterStatus.Connecting || _status === _types.SubscriptionAdapterStatus.Connected) {
        throw new Error(_subscribeAdapterConstants.subscriptionAdapterAlreadyInitialized);
      }

      if (_status === _types.SubscriptionAdapterStatus.Closed) {
        throw new Error(_subscribeAdapterConstants.subscriptionAdapterClosed);
      }

      client = new WebSocket(url);
      _status = _types.SubscriptionAdapterStatus.Connecting;

      var tryToSendPullEventsRequest = function tryToSendPullEventsRequest(attempts) {
        if (attempts === void 0) {
          attempts = pullEventsMaxAttempts;
        }

        if (pullEventsRequestId != null) {
          isWaitingForExtraPulling = true;
        } else if (client != null) {
          pullEventsRequestId = (0, _uuid.v4)();
          client.send(JSON.stringify({
            type: 'pullEvents',
            requestId: pullEventsRequestId,
            payload: {
              cursor: currentCursor
            }
          }));
          pullEventsTimeoutInstance = setTimeout(function () {
            pullEventsRequestId = null;

            if (attempts > 1) {
              tryToSendPullEventsRequest(attempts - 1);
            } else {
              // eslint-disable-next-line no-console
              console.warn("WebSocket pullEvents max attempts reached out");
              pullEventsTimeoutInstance = null;
            }
          }, pullEventsTimeout);
        }
      };

      client.onopen = function () {
        _status = _types.SubscriptionAdapterStatus.Connected;
        tryToSendPullEventsRequest();
      };

      client.onmessage = function (message) {
        try {
          var _JSON$parse = JSON.parse(message.data),
              type = _JSON$parse.type,
              requestId = _JSON$parse.requestId,
              payload = _JSON$parse.payload;

          switch (type) {
            case 'events':
              {
                tryToSendPullEventsRequest();
                break;
              }

            case 'pullEvents':
              {
                if (requestId === pullEventsRequestId) {
                  payload.events.forEach(function (event) {
                    onEvent(event);
                  });
                  currentCursor = payload.cursor;
                  pullEventsRequestId = null;

                  if (pullEventsTimeoutInstance != null) {
                    clearTimeout(pullEventsTimeoutInstance);
                    pullEventsTimeoutInstance = null;
                  }

                  if (isWaitingForExtraPulling) {
                    isWaitingForExtraPulling = false;
                    tryToSendPullEventsRequest();
                  }
                }

                break;
              }

            default:
              {
                // eslint-disable-next-line no-console
                console.warn("Unknown '" + type + "' socket message type");
              }
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('WebSocket message error', error);
        }
      };
    },
    close: function close() {
      if (_status !== _types.SubscriptionAdapterStatus.Connecting && _status !== _types.SubscriptionAdapterStatus.Connected) {
        throw new Error(_subscribeAdapterConstants.subscriptionAdapterNotInitialized + ": " + _status);
      }

      _status = _types.SubscriptionAdapterStatus.Closed;

      if (client != null) {
        client.close();
      }

      client = undefined;
      pullEventsRequestId = null;

      if (pullEventsTimeoutInstance != null) {
        clearTimeout(pullEventsTimeoutInstance);
        pullEventsTimeoutInstance = null;
      }
    },
    status: function status() {
      if (_status === _types.SubscriptionAdapterStatus.Connected && client != null && client.readyState === 1) {
        return _types.SubscriptionAdapterStatus.Ready;
      }

      return _status;
    }
  };
};

createClientAdapter.adapterName = 'ws';
var _default = createClientAdapter;
exports["default"] = _default;
//# sourceMappingURL=subscribe-adapter.js.map